import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import * as Api from './addressApi';
import {
  fetchCountriesRequest,
  fetchCountriesSuccess,
  fetchCountriesFailure,
  fetchStatesRequest,
  fetchStatesSuccess,
  fetchStatesFailure,
} from './addressSlice';

function extractItems(response) {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  return (
    response.data ||
    response.suggestion ||
    response.suggestions ||
    response.countries ||
    response.items ||
    response.result ||
    []
  );
}

function normalizeCountryOption(item) {
  if (!item) return null;
  if (typeof item === 'string') return { value: item, label: item };
  const value =
    item.value ??
    item.code ??
    item.country_code ??
    item.countryCode ??
    item.country ??
    item.key ??
    item.id ??
    null;
  const label =
    item.label ??
    item.name ??
    item.country_name ??
    item.countryName ??
    item.display_name ??
    item.text ??
    value;
  if (!value) return null;
  return { value: String(value), label: String(label) };
}

function normalizeStateOption(item) {
  if (!item) return null;
  if (typeof item === 'string') return { value: item, label: item };
  const code = item.state || item.code || item.value || item.key || null;
  const label = item.state_full_name || item.name || item.label || code;
  if (!code) return null;
  return { value: String(code), label: String(label || code) };
}

function* fetchCountriesSaga(action) {
  const section = action.payload?.section;
  if (!section) return;
  try {
    const apiFn = section === 'property' ? Api.fetchPropertyCountries : Api.fetchMailingCountries;
    const response = yield call(apiFn);
    const items = extractItems(response);
    const data = items.map(normalizeCountryOption).filter(Boolean);
    yield put(fetchCountriesSuccess({ section, data }));
  } catch (error) {
    console.error(`[addressSaga] Failed to fetch ${section} countries:`, error);
    yield put(
      fetchCountriesFailure({ section, error: error?.message || 'Failed to fetch countries' })
    );
  }
}

function* fetchStatesSaga(action) {
  const { section, country } = action.payload || {};
  if (!section || !country) return;
  try {
    const response = yield call(Api.fetchStates, { country });
    const items = extractItems(response);
    const data = items.map(normalizeStateOption).filter(Boolean);
    yield put(fetchStatesSuccess({ section, country, data }));
  } catch (error) {
    console.error(`[addressSaga] Failed to fetch ${section} states:`, error);
    yield put(
      fetchStatesFailure({ section, error: error?.message || 'Failed to fetch states' })
    );
  }
}

export default function* addressSaga() {
  yield all([
    takeEvery(fetchCountriesRequest.type, fetchCountriesSaga),
    takeLatest(fetchStatesRequest.type, fetchStatesSaga),
  ]);
}
